export function formatAddress(address: Record<string, unknown> | null): string {
  if (!address) return "-";
  const parts: string[] = [];
  if (address.adresse) {
    const adresser = address.adresse;
    if (Array.isArray(adresser)) parts.push(...adresser.filter(Boolean));
    else parts.push(String(adresser));
  }
  if (address.street) parts.push(String(address.street));
  if (address.postnummer || address.postalCode || address.postal_code) {
    const postal = address.postnummer || address.postalCode || address.postal_code;
    const city = address.poststed || address.city || "";
    parts.push(`${postal} ${city}`.trim());
  }
  if (address.land && address.land !== "Norge") parts.push(String(address.land));
  if (address.country && address.country !== "Norway" && address.country !== "Norge")
    parts.push(String(address.country));
  return parts.length > 0 ? parts.join(", ") : JSON.stringify(address);
}
